import type { BootstrapSummary } from '@core/entities/BootstrapSummary';

export type BootstrapGatewayErrorCode = 'offline' | 'request-failed' | 'retry-exhausted' | 'session-required';

export class BootstrapGatewayError extends Error {
  public constructor(
    public readonly code: BootstrapGatewayErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'BootstrapGatewayError';
  }
}

export interface BootstrapGateway {
  confirmJourneyStartAvailability(): Promise<void>;
  getBootstrapSummary(): Promise<BootstrapSummary>;
}